
import { createContext, ReactNode } from 'react';
import { AddressApi, CalendarApi } from '../../api-client';
import { AuthContext } from '../Auth/auth.provider';
import useStore from '../../helpers/useStore';
import { createApiConfig } from '../../api/createApiConfig';
import { useLocalObservable } from 'mobx-react';
import AddressStore from './addressStore';

interface AddressProviderProps {
  children: ReactNode;
}

export const AddressContext = createContext<AddressStore | null>(null);
AddressContext.displayName = 'AddressContext';

export const AddressProvider = ({ children }: AddressProviderProps) => {
  const AuthenticationStore = useStore(AuthContext);

  const apiClient = new AddressApi(createApiConfig());
  const store = useLocalObservable(
    () => new AddressStore(apiClient, AuthenticationStore)
  );

  return (
    <AddressContext.Provider value={store}>
      {children}
    </AddressContext.Provider>
  );
};